@if (isLoading()) {
  <lib-loader></lib-loader>
} @else {
  <div class="permissions-table h-full w-full overflow-x-auto whitespace-nowrap">
    <table class="w-full">
      <thead class="bg-neutral-50">
        <tr class="text-xs text-neutral-700 font-semibold">
          <th class="text-start max-w-[2.25rem]"></th>
          <th class="text-start">
            {{
              'workflow_details_table_add_member_screen_resource_type_label'
                | transloco
            }}
          </th>
          <th class="text-start">
            {{
              'workflow_details_table_add_member_screen_resource_label'
                | transloco
            }}
          </th>
          <th class="">
            {{
              'workflow_permission_details_screen_view_workflow_table_header'
                | transloco
            }}
          </th>
          <th class="">
            {{
              'workflow_permission_details_screen_trigger_new_requests_table_header'
                | transloco
            }}
          </th>
          <th class="">
            {{
              'workflow_permission_details_screen_view_all_requests_table_header'
                | transloco
            }}
          </th>

          <th>
            {{
              'workflow_details_table_add_member_screen_hold_resume_label'
                | transloco
            }}
          </th>

          <th class="">
            {{
              'workflow_details_table_add_member_screen_archive_label'
                | transloco
            }}
          </th>
          @if (isScheduleWorkflowToRunOnceEnabled()) {
            <th>
              {{
                'workflow_details_table_add_member_screen_view_workflow_schedules_label'
                  | transloco
              }}
            </th>
            <th>
              {{
                'workflow_details_table_add_member_screen_add_workflow_schedule_label'
                  | transloco
              }}
            </th>
            <th>
              {{
                'workflow_details_table_add_member_screen_edit_workflow_schedule_label'
                  | transloco
              }}
            </th>
            <th>
              {{
                'workflow_details_table_add_member_screen_cancel_workflow_schedule_label'
                  | transloco
              }}
            </th>
          }
          <th></th>
        </tr>
      </thead>

      <tbody>
        @for (member of tableData(); track $index; let i = $index) {
          <tr>
            <td class="text-neutral-900 text-xs font-medium bg-neutral-50">
              {{ (currentPage() - 1) * currentSize() + (i + 1) }}
            </td>

            <td>
              <div class="flex gap-md items-center">
                <p class="text-xs font-medium text-neutral-900">
                  {{
                    'workflow_details_table_add_member_screen_{' +
                      member.model_type +
                      '}_label' | transloco
                  }}
                </p>
              </div>
            </td>

            <td>
              <div class="flex gap-md items-center">
                <lib-avatar
                  [fullName]="member.model_data.name"
                  [img]="member?.model_data?.image?.url!"
                  borderRadius="rounded-full"></lib-avatar>
                <div>
                  <p class="text-xs font-medium text-neutral-900">
                    {{ member.model_data.name | truncate: 50 }}
                  </p>
                  <span class="text-xs font-normal text-neutral-500"
                    >{{
                      isOwner(member.permissions)
                        ? ('owner_label' | transloco)
                        : ('member_label' | transloco)
                    }}
                  </span>
                </div>
              </div>
            </td>

            <td>
              @if (handlePermissions('view', member.permissions)) {
                <ng-container [ngTemplateOutlet]="checkSvg" />
              }
            </td>

            <td>
              @if (handlePermissions('trigger', member.permissions)) {
                <ng-container [ngTemplateOutlet]="checkSvg" />
              }
            </td>

            <td>
              @if (handlePermissions('view_all', member.permissions)) {
                <ng-container [ngTemplateOutlet]="checkSvg" />
              }
            </td>

            <td>
              @if (handlePermissions('hold', member.permissions)) {
                <ng-container [ngTemplateOutlet]="checkSvg" />
              }
            </td>

            <td>
              @if (handlePermissions('archive', member.permissions)) {
                <ng-container [ngTemplateOutlet]="checkSvg" />
              }
            </td>

            @if (isScheduleWorkflowToRunOnceEnabled()) {
              <td>
                @if (
                  handlePermissions(
                    'view_workflow_schedule',
                    member.permissions
                  )
                ) {
                  <ng-container [ngTemplateOutlet]="checkSvg" />
                }
              </td>
              <td>
                @if (
                  handlePermissions('add_workflow_schedule', member.permissions)
                ) {
                  <ng-container [ngTemplateOutlet]="checkSvg" />
                }
              </td>
              <td>
                @if (
                  handlePermissions(
                    'edit_workflow_schedule',
                    member.permissions
                  )
                ) {
                  <ng-container [ngTemplateOutlet]="checkSvg" />
                }
              </td>
              <td>
                @if (
                  handlePermissions(
                    'cancel_workflow_schedule',
                    member.permissions
                  )
                ) {
                  <ng-container [ngTemplateOutlet]="checkSvg" />
                }
              </td>
            }

            <td class="text-center p-lg">
              <lib-action-list
                [style.visibility]="
                  !isOwner(member.permissions) ? 'visible' : 'hidden'
                "
                (itemClick)="itemClick($event, member)"
                [menuItems]="actionList">
              </lib-action-list>
            </td>
          </tr>
        } @empty {
          <tr>
            <td
              [attr.colspan]="isScheduleWorkflowToRunOnceEnabled() ? 13 : 9"
              class="py-8xl empty-table">
              <lib-table-empty-state
                [noDataTitle]="'table_no_data_title' | transloco"
                [noDataDescription]="'section_no_data_description' | transloco">
              </lib-table-empty-state>
            </td>
          </tr>
        }
      </tbody>
    </table>
  </div>

  <ng-template #removeUser>
    <div class="flex justify-center">
      <div
        class="flex justify-center items-center bg-destructive-50 p-lg rounded-full mb-xl">
        <lib-delete-icon [iconClass]="'size-8 text-destructive-500'" />
      </div>
    </div>

    <p class="text-lg text-center font-medium mb-sm text-neutral-900">
      {{
        'workflow_permission_details_screen_remove_user_popup_title' | transloco
      }}
    </p>

    <p class="text-sm text-neutral-500 text-center mb-4xl">
      {{
        'workflow_permission_details_screen_remove_user_popup_warning'
          | transloco
      }}
    </p>

    <div class="flex flex-col gap-md text-base font-medium">
      <button
        [disabled]="removingUser()"
        [class.opacity-30]="removingUser()"
        (click)="memberEmitterAction('remove', selectedMember()); closeModal()"
        class="bg-destructive-500 py-sm rounded-md text-white text-base cursor-pointer">
        {{
          'workflow_permission_details_screen_remove_owner_popup_yes_remove_it_button'
            | transloco
        }}
      </button>

      <button
        (click)="closeModal()"
        class="text-neutral-700 bg-white border border-neutral-300 py-sm rounded-md text-base cursor-pointer">
        {{
          'workflow_permission_details_screen_remove_owner_popup_no_keep_it_button'
            | transloco
        }}
      </button>
    </div>
  </ng-template>
}

<ng-template #checkSvg>
  <svg
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
    class="do-not-transform mx-auto text-primary-500"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12.5 2C6.99 2 2.5 6.49 2.5 12C2.5 17.51 6.99 22 12.5 22C18.01 22 22.5 17.51 22.5 12C22.5 6.49 18.01 2 12.5 2ZM17.28 9.7L11.61 15.37C11.47 15.51 11.28 15.59 11.08 15.59C10.88 15.59 10.69 15.51 10.55 15.37L7.72 12.54C7.43 12.25 7.43 11.77 7.72 11.48C8.01 11.19 8.49 11.19 8.78 11.48L11.08 13.78L16.22 8.64C16.51 8.35 16.99 8.35 17.28 8.64C17.57 8.93 17.57 9.4 17.28 9.7Z"
      fill="currentColor" />
  </svg>
</ng-template>
